const routes = [
    {
        path: '/',
        component: () => import('layouts/next/LandingLayout.vue'),
        children: [
            { path: '', component: () => import('pages/next/LandingPage.vue') },
            { path: ':alias', component: () => import('pages/next/LandingPage.vue') },
            { path: 'login', component: () => import('pages/next/user/Login.vue') },
            { path: 'signin', component: () => import('pages/auth-internal/AuthPage.vue') },
            { path: 'restore', component: () => import('pages/auth-internal/RestoreAuthPage.vue') },
            { path: 'register', component: () => import('pages/auth-internal/RegisterAuthPage.vue') },
            // { path: 'register', component: () => import('pages/next/user/Login.vue') },
            { path: 'buy-course/:alias', component: () => import('pages/desktop/BuyCourse.vue') },
            { path: 'pay-course', component: () => import('pages/desktop/PayForCourse.vue') },
            { path: 'offline/:id/networking-table', component: () => import('pages/next/NetworkingTable.vue') },
            { path: 'webinar/:id', name: 'shadow-webinar', component: () => import('pages/next/webinars/ShadowWebinar') },
            /*
            {
                path: 'portfolio',
                component: () => import('layouts/next/IndexLayout.vue'),
                children: [
                    { path: '', component: () => import('pages/next/MyProfile.vue') },
                ],
            },
            */
            {
                path: '',
                component: () => import('layouts/next/IndexLayout.vue'),
                children: [
                    { name: 'entry', path: 'entry', component: () => import('pages/next/Entry.vue') },
                    { name: 'entry-alias', path: ':alias/:verb', component: () => import('pages/next/Entry.vue') },
                ],
            },
            {
                path: 'webinar',
                component: () => import('layouts/next/IndexLayout.vue'),
                children: [
                    { path: '', component: () => import('pages/next/MyWebinar.vue') },
                ],
            },
            {
                path: 'course',
                component: () => import('layouts/next/IndexLayout.vue'),
                children: [
                    { path: '', component: () => import('pages/next/MyCourseNew.vue') },
                ],
            },
            {
                path: 'activity/:activityId',
                component: () => import('layouts/next/IndexLayout.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('pages/next/MyCourseNew.vue'),
                        children: [{ path: '', component: () => import('pages/next/MyCourse-atoms/MyCourseRoot') }],
                    },
                ],
            },
            {
                path: 'lesson/:lessonId',
                component: () => import('layouts/next/IndexLayout.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('pages/next/MyCourseNew.vue'),
                        children: [{ path: '', component: () => import('pages/next/MyCourse-atoms/MyCourseRoot') }],
                    },
                ],
            },
            {
                path: 'user/pay/success',
                component: () => import('pages/next/user/PaySuccess.vue'),
            },
            {
                path: 'user/pay/fail',
                component: () => import('pages/next/user/PayFail.vue'),
            },
            {
                path: 'pay',
                component: () => import('pages/next/Pay.vue'),
            },
            {
                path: 'user',
                component: () => import('layouts/next/IndexLayout.vue'),
                children: [
                    {
                        path: '',
                        name: 'profile-root',
                        component: () => import('pages/next/MyProfileNew.vue'),
                        children: [
                            {
                                path: '',
                                redirect: '/user/main-info',
                            },
                            {
                                path: 'main-info',
                                name: 'user-main-info',
                                component: () => import('pages/next/userProfile/UserMainInfo'),
                            },
                            {
                                path: 'personal-info/:section?',
                                name: 'user-personal-info',
                                component: () => import('pages/next/userProfile/UserPersonalInfo'),
                            },
                            {
                                path: 'user-payments',
                                name: 'user-payments',
                                component: () => import('pages/next/userProfile/UserPayments'),
                            },
                            {
                                path: 'user-help',
                                name: 'user-help',
                                component: () => import('pages/next/userProfile/UserHelp'),
                            },
                            {
                                path: 'user-education-documents',
                                name: 'user-education-documents',
                                component: () => import('pages/next/userProfile/UserEducationDocuments'),
                            },
                        ],
                    },
                    { path: 'profile', name: 'profile', redirect: '/' },
                    { path: 'portfolio', component: () => import('pages/portfolio/UserPortfolioPage.vue') },
                    { path: 'messages', component: () => import('pages/next/MyMessages.vue') },
                    { path: 'messages/:id', component: () => import('pages/next/MyMessages.vue') },
                    {
                        path: 'my-course',
                        component: () => import('pages/next/MyCourseNew.vue'),
                        children: [
                            {
                                path: '',
                                name: 'my-course',
                                component: () => import('pages/next/MyCourse-atoms/MyCourseRoot'),
                            },
                            {
                                path: ':themeId/:lessonId',
                                name: 'my-course-lesson',
                                component: () => import('pages/next/MyCourse-atoms/MyCourseLesson'),
                                children: [
                                    {
                                        path: ':activityId',
                                        name: 'my-course-activity',
                                        component: () => import('pages/next/MyCourse-atoms/MyCourseActivity'),
                                    },
                                ],
                            },
                        ],
                    },
                    { path: 'courses', component: () => import('pages/next/Courses.vue') },
                    { path: 'webinar', component: () => import('pages/next/MyWebinar.vue') },
                    { path: 'contacts', component: () => import('pages/next/Contacts.vue') },
                    { path: 'offer', component: () => import('pages/next/MyOffer.vue') },
                    { path: 'start-course/:alias', component: () => import('pages/desktop/StartCourse.vue') },

                    { name: 'buy-course', path: 'buy-course', component: () => import('pages/desktop/BuyCourse.vue') },
                    { name: 'pay-course', path: 'pay-course', component: () => import('pages/desktop/PayForCourse.vue') },
                    { name: 'course-info', path: 'course-info', component: () => import('pages/desktop/CourseInfo.vue') },
                    { path: ':alias', component: () => import('pages/desktop/CourseInfo.vue') },
                    {
                        name: 'start-task', path: 'start-task', component: () => import('pages/desktop/StartTask.vue'),
                    },
                    {
                        path: 'login',
                        component: () => import('pages/next/user/Login.vue'),
                    },
                    {
                        name: 'recruiter',
                        path: 'recruiter',
                        component: () => import('pages/next/recruiter/Recruiter.vue'),
                        children: [
                            { name: 'recruiter-index', path: '', component: () => import('pages/next/recruiter/RecruiterIndex.vue') },
                            { name: 'recruiter-subscription', path: 'subscription', component: () => import('pages/next/recruiter/subscription/RecruiterSubscription.vue') },
                            { name: 'recruiter-favorites', path: 'favorites', component: () => import('pages/next/recruiter/favorites/RecruiterFavorites.vue') },
                        ],
                    },
                    { path: 'projects', component: () => import('pages/next/projects/Projects.vue') },
                    {
                        name: 'project',
                        path: 'project/:uuid',
                        component: () => import('layouts/next/ProjectLayout.vue'),
                        children: [
                            { name: 'project-main', path: 'main', component: () => import('pages/next/projects/ProjectMain.vue') },
                            { name: 'project-team', path: 'team', component: () => import('pages/next/projects/ProjectTeam.vue') },
                            { name: 'project-docs', path: 'docs/:alias', component: () => import('pages/next/projects/ProjectDocs.vue') },
                        ],
                    },
                    {
                        path: '/friends',
                        component: () => import('pages/friends/Friends.vue'),
                    },
                    // {
                    //     path: 'path',
                    //     component: () => import('pages/bonuses/UserPath.vue'),
                    // },
                    // {
                    //     path: 'showcase',
                    //     component: () => import('pages/bonuses/UserShowcase.vue'),
                    // },
                    // {
                    //     path: 'showcase/:productId',
                    //     component: () => import('pages/bonuses/ProductShowcase.vue'),
                    // },
                    // {
                    //     path: 'my-orders',
                    //     component: () => import('pages/bonuses/UserOrders.vue'),
                    // },
                ],
            },
            { path: '/table', component: () => import('pages/next/Timetable.vue') },
        ],
    },

    {
        path: '/school',
        component: () => import('pages/school/School.vue'),
    },
    {
        path: '/signin2',
        component: () => import('pages/signin/LeaderIdSigninPage.vue'),
    },
    {
        path: '/page',
        component: () => import('pages/cluster/SlideContentPage.vue'),
        children: [
            {
                path: ':themeId/:lessonId',
                component: () => import('pages/next/MyCourse-atoms/MyCourseLesson'),
                children: [
                    {
                        path: ':activityId',
                        name: 'page-emulate-activity',
                        component: () => import('pages/next/MyCourse-atoms/MyCourseActivity'),
                    },
                ],
            },
        ],
    },
    {
        path: '/partner',
        component: () => import('pages/partner/Partner.vue'),
    },
    {
        path: '/partner-info',
        component: () => import('pages/friends/FriendInfo.vue'),
    },
    {
        path: '/friends/login',
        component: () => import('pages/friends/FriendsLogin.vue'),
    },
    {
        path: '/master-su',
        component: () => import('pages/friends/FriendsMasterView.vue'),
    },

    {
        path: '/portfolio/:name', // портфолио пользователя
        component: () => import('pages/portfolio/Portfolio.vue'),
    },
    {
        path: '/2035auth',
        component: () => import('pages/2035.Auth.vue'),
    },
    {
        path: '/incorrect_url',
        component: () => import('pages/IncorrectUrlPage.vue'),
    },
    {
        path: '/go/:catchAll(.*)*',
        component: () => import('layouts/MainLayout.vue'),
    },
    /*
    {
        path: '/hn5N-892a',
        component: () => import('layouts/OldAdminLayout.vue'),
        children: [
            { path: '', component: () => import('pages/admin/AdminPage.vue') },
            { path: 'edit-container', name: 'edit-container', component: () => import('pages/admin/EditContainerPage.vue') },
        ],
    },
    */
    { path: '/admin-login', component: () => import('pages/admin/AdminLoginPage.vue') },

    // Внешние формы
    {
        path: '/external',
        component: () => import('layouts/ExternalLayout.vue'),
        children: [
            {
                path: 'course/:courseId',
                component: () => import('pages/sot.bot.admin/courses/CoursesIndex.vue'),
            },
            {
                path: 'webinars-schedule',
                component: () => import('pages/external/WebinarsSchedulePage.vue'),
            },
            {
                path: 'webinars',
                component: () => import('pages/sot.bot.admin/webinars/WebinarsPage.vue'),
            },
            {
                path: 'webinars/:id',
                component: () => import('pages/sot.bot.admin/webinars/WebinarDetail.vue'),
            },
            { path: 'users/exercise/:id', component: () => import('pages/sot.bot.admin/taskExercise/ExerciseFeed.vue') },
            { path: 'exercises', component: () => import('pages/sot.bot.admin/taskExercise/ExerciseFeed.vue') },
            { path: 'chat', component: () => import('pages/sot.bot.admin/operators/OperatorChat.vue') },
        ],
    },
    // Новая админка (объединенная)
    {
        path: '/jM5a-1Pq8',
        component: () => import('layouts/AdminLayout.vue'),
        children: [
            { path: '', redirect: '/jM5a-1Pq8/users' },
            {
                path: '/jM5a-1Pq8/users',
                children: [
                    { path: '', redirect: '/jM5a-1Pq8/users/users' },
                    { path: '/jM5a-1Pq8/users/users', name: 'users', component: () => import('pages/sot.bot.admin/Users.vue') },
                    { path: '/jM5a-1Pq8/users/user-stats', name: 'user-stats', component: () => import('pages/sot.bot.admin/UserStatistics.vue') },
                    { path: '/jM5a-1Pq8/course', component: () => import('pages/sot.bot.admin/courses/CoursesIndex.vue') },
                    { path: '/jM5a-1Pq8/users/mailings', component: () => import('pages/sot.bot.admin/MailingsTable.vue') },
                    { path: '/jM5a-1Pq8/users/edit-mailing', name: 'edit-mailing', component: () => import('pages/sot.bot.admin/Mailings.vue') },
                    { path: '/jM5a-1Pq8/users/chat', component: () => import('pages/sot.bot.admin/Chat.vue') },
                    { path: '/jM5a-1Pq8/users/user-chat', name: 'user-chat', component: () => import('pages/sot.bot.admin/UserChat.vue') },
                    { path: '/jM5a-1Pq8/users/user-balance', name: 'user-balance', component: () => import('pages/sot.bot.admin/userBalance/UserBalance.vue') },
                    { path: '/jM5a-1Pq8/users/user-products', name: 'user-products', component: () => import('pages/sot.bot.admin/userProducts/UserProducts.vue') },
                    { path: '/jM5a-1Pq8/users/stats', component: () => import('pages/sot.bot.admin/Stats.vue') },
                    { path: '/jM5a-1Pq8/users/certificates', component: () => import('pages/sot.bot.admin/Certificates.vue') },
                    { path: '/jM5a-1Pq8/users/user-certificate', name: 'user-certificate', component: () => import('pages/sot.bot.admin/UserCertificate.vue') },
                    { path: '/jM5a-1Pq8/users/setup-autophone', component: () => import('pages/sot.bot.admin/SetupAutophone.vue') },
                    { path: '/jM5a-1Pq8/users/edit-user-profile', name: 'edit-user-profile', component: () => import('pages/sot.bot.admin/UserProfile.vue') },
                    { path: '/jM5a-1Pq8/users/user-input-table', name: 'user-input-table', component: () => import('pages/sot.bot.admin/UserInputTable.vue') },
                    { path: '/jM5a-1Pq8/users/poll-table', name: 'poll-table', component: () => import('pages/sot.bot.admin/PollTable.vue') },
                    { path: '/jM5a-1Pq8/users/users-input', name: 'users-input', component: () => import('pages/sot.bot.admin/UsersInputTable.vue') },
                    { path: '/jM5a-1Pq8/users/likes-input', name: 'likes-input', component: () => import('pages/sot.bot.admin/LikesInputTable.vue') },
                    { path: '/jM5a-1Pq8/users/user-cert2', name: 'user-cert2', component: () => import('pages/sot.bot.admin/UserCert2.vue') },
                    { path: '/jM5a-1Pq8/users/user-trace-courses', name: 'user-trace-courses', component: () => import('pages/sot.bot.admin/UserTraceCourses.vue') },
                    { path: '/jM5a-1Pq8/users/user-trace-traces', name: 'user-trace-traces', component: () => import('pages/sot.bot.admin/UserTraceTraces.vue') },
                    { path: '/jM5a-1Pq8/users/user-trace-content', name: 'user-trace-content', component: () => import('pages/sot.bot.admin/UserTraceContent.vue') },
                    { path: '/jM5a-1Pq8/users/user-entry-diag', name: 'user-entry-diag', component: () => import('pages/sot.bot.admin/UserEntryDiag.vue') },
                    { path: '/jM5a-1Pq8/users/user-courses', name: 'user-courses', component: () => import('pages/sot.bot.admin/UserCourses.vue') },
                    { path: '/jM5a-1Pq8/users/user-course-info', name: 'user-course-info', component: () => import('pages/sot.bot.admin/UserCourseInfo.vue') },
                    { path: '/jM5a-1Pq8/users/add-update-users', name: 'add-update-users', component: () => import('pages/sot.bot.admin/AddUpdateUsers.vue') },
                    { path: '/jM5a-1Pq8/users/exercise/:id', name: 'users-exercise-id', component: () => import('pages/sot.bot.admin/taskExercise/ExerciseFeed.vue') },
                    { path: '/jM5a-1Pq8/users/exercise', name: 'users-exercise', component: () => import('pages/sot.bot.admin/taskExercise/ExerciseFeed.vue') },
                    { path: '/jM5a-1Pq8/users/groups', component: () => import('pages/sot.bot.admin/groups/GroupsIndex.vue') },
                    { path: '/jM5a-1Pq8/users/applications', component: () => import('pages/sot.bot.admin/Applications.vue') },
                    { path: '/jM5a-1Pq8/users/storage', component: () => import('pages/sot.bot.admin/storageTable/StorageTable.vue') },
                    { path: '/jM5a-1Pq8/users/schools', component: () => import('pages/sot.bot.admin/schoolsTable/SchoolsTable.vue') },
                    { path: '/jM5a-1Pq8/users/events', component: () => import('pages/sot.bot.admin/Events.vue') },
                    { path: '/jM5a-1Pq8/users/platform', component: () => import('pages/sot.bot.admin/PlatformSettings.vue') },
                    { path: '/jM5a-1Pq8/users/templates', component: () => import('pages/sot.bot.admin/templatesSettings/TemplatesSettings.vue') },
                    { path: '/jM5a-1Pq8/users/messages-log', component: () => import('pages/sot.bot.admin/messagesLog/MessagesLog.vue') },
                    { path: '/jM5a-1Pq8/mockup', component: () => import('src/pages/mockup/Mockup.vue') }, // редактор макетов
                    { path: '/jM5a-1Pq8/documents', component: () => import('pages/sot.bot.admin/documents/DocumentsIndex.vue') }, // документы
                    { path: '/jM5a-1Pq8/payments', component: () => import('pages/sot.bot.admin/payments/PaymentsTable.vue') }, // оплаты
                    { path: '/jM5a-1Pq8/players', component: () => import('pages/sot.bot.admin/players/PlayersSettings.vue') }, // плееры
                    { path: '/jM5a-1Pq8/operators', component: () => import('pages/sot.bot.admin/operators/OperatorsSettings.vue') }, // операторы
                    { path: '/jM5a-1Pq8/media-service', component: () => import('pages/sot.bot.admin/library/MediaService.vue') }, // медиасервис
                    { path: '/jM5a-1Pq8/schedule', component: () => import('pages/sot.bot.admin/schedule/ScheduleIndex.vue') }, // мое расписание
                    { path: '/jM5a-1Pq8/denied', component: () => import('pages/sot.bot.admin/denied/DeniedPage.vue') }, // плееры
                    { path: '/jM5a-1Pq8/chat', component: () => import('pages/sot.bot.admin/operators/OperatorChat.vue') },
                    { path: '/jM5a-1Pq8/links', component: () => import('pages/sot.bot.admin/links/LinksSettings.vue') }, // ссылки
                    { path: '/jM5a-1Pq8/auth-settings', component: () => import('pages/auth-internal/authSettings/AuthSettings.vue') }, // настройки авторизации
                    { path: '/jM5a-1Pq8/tgbot', component: () => import('pages/sot.bot.admin/tgbot/Index.vue') }, // чат-бот (тг, сценарии)
                    { path: '/jM5a-1Pq8/projects', component: () => import('pages/sot.bot.admin/projects/Index.vue') }, // проекты
                    { path: '/jM5a-1Pq8/helps', component: () => import('pages/sot.bot.admin/helps/Index.vue') }, // Справки
                    // { path: '/jM5a-1Pq8/path', component: () => import('pages/sot.bot.admin/path/IndexPath.vue') }, // Путь клиента
                    // { path: '/jM5a-1Pq8/bonuses', component: () => import('pages/sot.bot.admin/bonuses/BonusesPage.vue') }, // Бонусы клиента
                    { path: '/jM5a-1Pq8/reps', component: () => import('pages/sot.bot.admin/reps/RepsIndex.vue') }, // Представители
                    { path: '/jM5a-1Pq8/providers', component: () => import('pages/sot.bot.admin/providers/ProvidersIndex.vue') }, // Провайдеры
                    { path: '/jM5a-1Pq8/teachers', component: () => import('pages/sot.bot.admin/teachers/TeachersIndex.vue') }, // Учителя
                    { path: '/jM5a-1Pq8/agents', component: () => import('pages/sot.bot.admin/agents/AgentsIndex.vue') }, // Агенты
                    { path: '/jM5a-1Pq8/inspectors', component: () => import('pages/sot.bot.admin/inspectors/InspectorsIndex.vue') }, // Контроллёры
                    { path: '/jM5a-1Pq8/regions', component: () => import('pages/sot.bot.admin/regions/RegionsIndex.vue') }, // Регионы
                    { path: '/jM5a-1Pq8/accounts', component: () => import('pages/sot.bot.admin/accounts/AccountsTable.vue') }, // Аккаунты Кампуса
                    { path: '/jM5a-1Pq8/modulePay', component: () => import('pages/sot.bot.admin/modulePay/ModulePayIndex.vue') }, // Оплаты
                    { path: '/jM5a-1Pq8/typePayConditions', component: () => import('pages/sot.bot.admin/modulePay/TypePayConditions.vue') }, // типовые условия
                ],
            },
            {
                path: '/jM5a-1Pq8/courses',
                component: () => import('pages/sot.bot.admin/courses/CoursesIndex.vue'),
            },
            {
                path: '/jM5a-1Pq8/subscriptions',
                component: () => import('pages/sot.bot.admin/subscriptions/SubscriptionsIndex.vue'),
            },
            {
                path: '/jM5a-1Pq8/pages',
                component: () => import('layouts/OldAdminLayout.vue'),
                children: [
                    { path: '', component: () => import('pages/admin/AdminPage.vue') },
                    { path: '/jM5a-1Pq8/pages/edit-container', name: 'edit-container', component: () => import('pages/admin/EditContainerPage.vue') },
                ],
            },
            { path: '/jM5a-1Pq8/messages', component: () => import('pages/sot.bot.admin/Chat.vue') },
            { path: 'edit-container', name: 'edit-container', component: () => import('pages/admin/EditContainerPage.vue') },
            {
                path: '/jM5a-1Pq8/partners',
                component: () => import('pages/sot.bot.admin/partners/PartnersTable.vue'),
            },
            {
                path: '/jM5a-1Pq8/potential',
                component: () => import('pages/sot.bot.admin/potential/PotentialUsersTable.vue'),
            },
            {
                path: '/jM5a-1Pq8/import',
                component: () => import('pages/sot.bot.admin/import/ImportIndex.vue'),
            },
            {
                path: '/jM5a-1Pq8/content',
                component: () => import('pages/sot.bot.admin/content/ContentPage.vue'),
            },
            {
                path: '/jM5a-1Pq8/content/:section',
                component: () => import('pages/sot.bot.admin/content/ContentPage.vue'),
            },
            // сайт
            {
                name: 'site',
                path: '/jM5a-1Pq8/site',
                component: () => import('pages/sot.bot.admin/site/SiteIndex.vue'),
                children: [
                    {
                        name: 'site-tab',
                        path: ':tab',
                        component: () => import('pages/sot.bot.admin/site/SiteIndex.vue'),
                    },
                ],
            },
            {
                path: '/jM5a-1Pq8/webinars',
                component: () => import('pages/sot.bot.admin/webinars/WebinarsPage.vue'),
            },
            {
                path: '/jM5a-1Pq8/webinars/:id',
                component: () => import('pages/sot.bot.admin/webinars/WebinarDetail'),
            },
        ],
    },
    {
        path: '/jM5a-1Pq8/test1',
        component: () => import('pages/next/user/TestPage.vue'),
    },
    {
        path: '/jM5a-1Pq8/search',
        component: () => import('pages/sot.bot.admin/search/SearchUserPage.vue'),
    },
    {
        path: '/bd0f-d569/user-dialog',
        component: () => import('pages/sot.bot.admin/userDialog/UserDialog'),
    },
    // Регистрация ГУ
    {
        path: '/reg',
        component: () => import('layouts/RegLayout'),
        children: [
            { path: '', component: () => import('pages/reg/RegRootPage.vue') },
            { path: 'adult', component: () => import('pages/reg/RegAdult.vue') },
        ],
    },
    { path: '/gu', component: () => import('pages/GU') },

    // конструктор страниц
    // localhost:8080/hn5N-892a

    // админка бота
    // localhost:8080/jM5a-1Pq7

    // Always leave this as last one,
    // but you can also remove it
    {
        path: '/:catchAll(.*)*',
        component: () => import('pages/Error404.vue'),
    },
    {
        path: '/404',
        component: () => import('pages/Error404.vue'),
    },
];

export default routes;
